<ng-container *ngIf="!isLoading && annualPlan && weeks; else noActiveAnnualPlan">
    <figure [ngClass]="viewMode">
        <div class="axis-y">
            <div class="macrocycle" [ngClass]="isEditMode ? 'edit' : ''"><span>{{ 'MacroCycles' | translate }}</span></div>
            <div class="phases" [ngClass]="isEditMode ? 'edit' : ''"><span>{{ 'Phases' | translate }}</span></div>
            <div class="percents">
                <ul>
                    <li>100 %</li>
                    <li>90 %</li>
                    <li>80 %</li>
                    <li>70 %</li>
                    <li>60 %</li>
                    <li>50 %</li>
                    <li>40 %</li>
                    <li>30 %</li>
                    <li>20 %</li>
                    <li>10 %</li>
                </ul>
            </div>
            <div class="accents">{{ 'Accents' | translate }}</div>
            <div class="weeks">{{ 'Week' | translate }}</div>
        </div>

        <div class="graph-inner" (scroll)="onScroll($event)" horizontalScrollDirective #scrollable>
            <div class="graph" [ngStyle]="{'width': chartWidth + 'px'}">

                <div class="selector" [ngClass]="isEditMode ? 'edit' : ''">
                    <ul>
                        <li *ngFor="let week of weeks" (click)="onWeekClicked(week)" [ngClass]="{'active': clickedWeek && clickedSelector == week.id}" matRipple>
              <span class="macro-cycle" (click)="isEditMode && addMacroCycle(week)">
                  <i class="material-icons" *ngIf="isEditMode">
                    add
                    </i>
              </span>
                            <span class="phase" (click)="isEditMode && addPhase(week)">
                  <i class="material-icons" *ngIf="isEditMode">
                    add
                    </i>
              </span>
                        </li>
                    </ul>
                </div>

                <div class="legend-top">
                    <div class="macrocycles">
                        <ul>
                            <li [ngClass]="isEditMode ? 'edit-mode':''" *ngFor="let annualMacroCycle of annualPlanMacroCycles"
                                [ngStyle]="{'left': ((annualMacroCycle.weekFrom??1) * 30) - 30 + 'px', 'width': ((annualMacroCycle.weekTo??0) - (annualMacroCycle.weekFrom??0) + 1) * 30 +'px'}" (click)="isEditMode && onMacroCycleClicked(annualMacroCycle)">
                              <span *ngIf="annualMacroCycle.macroCycle" [ngStyle]="{'background-color': annualMacroCycle.macroCycle?.hexadecimalColor}">
                                {{ annualMacroCycle.macroCycle.name }}
                              </span>
                            </li>
                        </ul>
                    </div>
                    <div class="phases">
                        <ul>
                            <li *ngFor="let annualPlanPhase of annualPlanPhases" [ngStyle]="{'left': ((annualPlanPhase.weekFrom??1) * 30) - 30 + 'px', 'width': ((annualPlanPhase.weekTo??0) - (annualPlanPhase.weekFrom??0) + 1) * 30 +'px'}" (click)="isEditMode && onPhaseClicked(annualPlanPhase)">
                                <span *ngIf="annualPlanPhase.phase" [ngStyle]="{'background': annualPlanPhase.phase.hexadecimalColor}" [ngClass]="isEditMode?  'edit-mode': ''"></span>
                            </li>

                            <!--
                            <li *ngFor="let data of annualPlanPhases" [ngStyle]="{'width': (data.weekTo - data.weekFrom) * 30 + 'px', 'background': data.phase.hexadecimalColor}"></li>
                            -->
                        </ul>
                    </div>
                </div>
                <div class="chart">
                    <div class="no-data" *ngIf="!hasData()">
                        {{ 'message.no_data' | translate }}
                    </div>
                    <div class="horizontal-lines">
                        <ul>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    </div>
                    <div class="chart-lines">
                        <svg [attr.viewBox]="chartViewBox">
                            <defs>
                                <linearGradient id="grad2" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0" style="stop-color:rgba(110,110,110,0.4);stop-opacity:0.4" />
                                    <stop offset="1" style="stop-color:rgba(216,216,216,0.4);stop-opacity:0.4" />
                                </linearGradient>
                            </defs>
                            <polygon
                                    fill="url(#grad2)"
                                    stroke="#787878"
                                    stroke-width="0"
                                    [attr.points]="chartSvgPoints"
                            />
                        </svg>
                    </div>
                    <div class="col" *ngFor="let week of weeks">
                        <div class="bar">
                            <span class="block sport" [ngStyle]="{'height': week.sportPercent + '%'}"><span class="bar-value" [ngClass]="{'active': clickedSelector == week.id}">{{ week.sportPercent }}</span></span>
                            <span class="block physical" [ngStyle]="{'height': week.physicalPercent + '%'}"><span class="bar-value" [ngClass]="{'active': clickedSelector == week.id}">{{ week.physicalPercent }}</span></span>
                        </div>
                    </div>
                    <div class="chart-lines-above">
                        <svg [attr.viewBox]="chartViewBox">
                            <defs>
                                <linearGradient id="grad2" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" style="stop-color:rgb(110,110,110);stop-opacity:0.4" />
                                    <stop offset="100%" style="stop-color:rgb(216,216,216);stop-opacity:0.4" />
                                </linearGradient>
                            </defs>
                            <polygon
                                    fill="none"
                                    stroke="#787878"
                                    stroke-width="2"
                                    [attr.points]="chartSvgPoints"
                            />

                        </svg>
                    </div>
                </div>

                <div class="legend">
                    <div class="weeks">
                        <div class="week-accents">
                            <ul>
                                <li *ngFor="let week of weeks" class="week">
                                    <ul class="accents">
                                        <li *ngFor="let category of week.exerciseCategories" [ngStyle]="{'width': 100 / week.exerciseCategories.length + '%', 'background': category.colorHex}"><span></span></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>

                        <div class="week-number">
                            <ul>
                                <li *ngFor="let week of weeks">
                                    <span>{{ week.realWeekNumber || week.weekNumber }}</span>
                                    <div class="has-event" *ngIf="week.comment"></div>
                                </li>
                            </ul>
                        </div>
                        <div class="week-name" *ngIf="showMonths">
                            <ul>
                                <li *ngFor="let data of dayInMonths" [ngStyle]="{'width': data.width + '%'}"><span [matTooltip]="(data.month|appDate:'MMM yyyy') ?? ''">{{ data.month|appDate:'MMM yyyy':'':currentLang }}</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </figure>
</ng-container>

<ng-template #noActiveAnnualPlan>
    <span class="no-active-annual-plan-message">{{ 'NoActiveAnnualPlanMessage'|translate }}</span>
</ng-template>
